module.exports = __webpack_public_path__ + "static/media/ic-hours-large.752f1e81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-hours-large.svg
// module id = 779
// module chunks = 0